import { Component, inject, Input, input, OnChanges, OnDestroy, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { RentalPropertyOwner } from '../../../domain/model/properties/rentalPropertyOwners';
import { OwnerCompanyAddComponent } from '../../register/owner-company-add/owner-company-add.component';
import { Dialog } from '@angular/cdk/dialog';
import { PropertyOwner } from '../../../domain/model/enrollment/propertyOwner';
import { RentalProperty } from '../../../domain/model/properties/rentalProperty';
import { PropertyService } from '../../../domain/service/propertyService';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../../register/dialog-confirm/dialog-confirm.component';

const OWNER_DATA: RentalPropertyOwner[] = [ 
];
@Component({
  selector: 'app-properties-detail-owners',
  templateUrl: './properties-detail-owners.component.html',
  styleUrl: './properties-detail-owners.component.css'
})
export class PropertiesDetailOwnersComponent implements OnChanges, OnDestroy{
  constructor(private propertyService: PropertyService, private matDialog: MatDialog){}
  ngOnDestroy(): void {
    OWNER_DATA.length = 0;
  }
  @Input() dataOwners! :RentalPropertyOwner[];  
  @Input() rentalProperty!: RentalProperty;
  @Output() formChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasChange: boolean = false;
  dialog = inject(Dialog);
  dataSource = new MatTableDataSource(OWNER_DATA);
  displayedColumns: string[] = ['firstName', 'lastName', 'email','phone','action'];
  newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  addNewPropertyOwner() {
    // Validar que no se exceda el límite de 3 propietarios adicionales
    if (OWNER_DATA.length >= 3) {
      // Mostrar mensaje de consola como alternativa a la notificación
      console.warn("Maximum of 3 additional owners allowed");
      return;
    }

    let owner : RentalPropertyOwner = {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      internalId: this.newGuid(),
      streetAddress: '',
      aptUnitSuite: '',
      city: '',
      zipCode: '',
      internationalAddressName: '',
      internationalPoboxNumber: '',
      internationalCityStateProvince: '',
      stateId: 0,
      countryId: 0,
      addressType: 0,
      accountPropertyId: 0,
      id: 0,
      accountId: 0,
      addressName: '',
      streetAddressOrPoBox: '',
      cityStateProvince: ''
    };
     

    const dialogRef = this.dialog.open<RentalPropertyOwner>(OwnerCompanyAddComponent, {
      width: '500px',
      maxHeight: '90vh',
      disableClose: true,
      data: {owner: owner},
    });
  
    dialogRef.closed.subscribe(result => {
      this.hasChange = true;
      this.formChanged.emit(true);
       if(result){
        result.accountPropertyId = this.rentalProperty?.id?? 0;
        result.accountId = this.rentalProperty?.accountID??0;
    OWNER_DATA.push(result);
    this.dataSource = new MatTableDataSource(OWNER_DATA); 
       }
    });
   
  }

  editOwner (owner : RentalPropertyOwner){
    const dialogRef = this.dialog.open<PropertyOwner>(OwnerCompanyAddComponent, {
      width: '500px',
      maxHeight: '90vh',
      disableClose: true,
      data: {owner: owner},
    });
  
    dialogRef.closed.subscribe(result => {

       if(result){
         this.hasChange = true;
          this.formChanged.emit(true);
        let index  = OWNER_DATA.findIndex(e => e.id == result.id);
        
       OWNER_DATA[index].firstName = result.firstName;
       OWNER_DATA[index].lastName = result.lastName;
       OWNER_DATA[index].email = result.email;
       OWNER_DATA[index].phoneNumber = result.phoneNumber;
    this.dataSource = new MatTableDataSource(OWNER_DATA); 
       }
    });
  }

  removeOwner (index: number){
    const dialogRef = this.matDialog.open(DialogConfirmComponent, {
      width: '500px',
      height: '210px',
      data: {
        title: 'Delete Owner',
        message: 'Are you sure you want to delete this owner?',
        confirmButtonText: 'DELETE',
        cancelButtonText: 'CANCEL'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.hasChange = true;
        this.formChanged.emit(true);
        OWNER_DATA.splice(index, 1);
        this.dataSource = new MatTableDataSource(OWNER_DATA); 
      }
    });
    }

    ngOnChanges(changes: SimpleChanges): void { 
      if (changes['dataOwners'] && changes['dataOwners'].currentValue) {
        this.dataOwners.forEach(element => {
          OWNER_DATA.push(element)
        });
      }
    }
getOwners(): RentalPropertyOwner[] {
  return OWNER_DATA
}
    save(): void {
      if(this.hasChange){
        this.propertyService.updateOwners(OWNER_DATA).subscribe({
          next: (response) => {
        
          },
          error: (error) => {
          
          },
          complete :() =>{ 
          }
        });
      }

      
    }
}
